import React from "react";
import { SiteLayout } from "./src/components";

const wrapPageElement: React.FC<{ element: React.FC; props: unknown }> = ({
  element,
  props,
}) => <SiteLayout {...props}>{element}</SiteLayout>;

export default wrapPageElement;
